module.exports = __webpack_public_path__ + "static/img/智能手工课堂2.438fb1fc.png";